/**
 * mixins
 */
import {$http, http} from '@utils';
import api from '@utils/api';
import CheckVcodeParam from "../../pages/safe/classes/checkVcodeParam";
export default {
  data () {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 20 },
        },
      },
      formItemLayoutCenter: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
      rules: {
        password: [
          { required: true, message: '请输入密码' },
          { pattern: new RegExp(this.$store.state.securityConfig.pwdReg), message: this.$store.state.securityConfig.pwdValidMsg},
          { validator: this.validatePassword}
        ],
        confirmPassword: [
          { required: true, message: '请确认密码' },
          { pattern: new RegExp(this.$store.state.securityConfig.pwdReg), message: this.$store.state.securityConfig.pwdValidMsg },
          { validator: this.compareToFirstPassword}
        ],
        phone: [
          { required: true, message: '手机号必须输入' },
          { pattern: new RegExp(/^1\d{10}$/, 'g'), message: '请输入正确格式的手机号' },
          { validator: this.validatePhone }
        ],
        email: [
          { required: true, message: '邮箱必须输入' },
          { type: 'email', message: '请输入正确的邮箱' },
          { validator: this.validateEmail }
        ],
        name: [
          { required: true, message: '请输入名称' },
          { pattern: new RegExp(/^(?![A-Za-z0-9]+$)[\u4e00-\u9fa5A-Za-z0-9]{0,3}$/, 'i'), message: '3个字符以下' }
        ],
        nickName: [
          { required: true, message: '请输入昵称' },
          { pattern: new RegExp(/^([\u4e00-\u9fa5A-Za-z])[\u4e00-\u9fa5A-Za-z0-9\-]{0,11}$/, 'i'), message: '限1-12位字符，中文或字母开头，支持中文、数字、字母、-的组合' },
          { validator: this.validateName }
        ],
      },
      isDisabled:true
    }
  },
  watch: {
      form: {
          handler: function (newForm) {
              this.isDisabled = Object.keys(newForm).some(key => {
                  return !newForm[key].value
              })
          },
          deep: true
      }
  },
  methods: {
    /**
     * 校验名称唯一
     * @param name
     * @return {Promise<boolean>}
     */
    async validNickName (nickName) {
      const { code, data } = await $http.get(`${api.mainHost}${api.mainContentPath}/account/validNickName.do`, {
        params: {
          nickName
        }
      })
      return code === '1' && !data
    },
    async validEmail (email) {
      const { code, data } = await $http.get(`${api.mainHost}${api.mainContentPath}/account/validMail.do`, {
        params: {
          email
        }
      })
      return code === '1' && data
    },
    async validPhone (v) {
      const _api = `${api.mainHost}/portal-api/account/validPhone.do`
      const res = await $http.get(`${_api}?phone=${v}`)
      if (res.code === '1') {
        return res.data
      } else {
        console.log(res.msg)
      }
    },
    /**
     * 校验验证码
     * @param phone
     * @param vCode
     * @return {Promise<boolean>}
     */
    async checkVcode (phone, vCode) {
      const { code, msg } = await this.checkPicCode(new CheckVcodeParam(phone, vCode))
      if (code * 1 !== 1) {
        this.$message.error(msg || '系统异常');
      }
      return code === '1'
    },
    /**
     * 校验逻辑
     * @param field {string} 表单域名
     * @param v {string} 值
     */
    async validators (field, v) {
      const status = ['success', 'warning', 'error', 'validating'];
      const mapper = {
        async name (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '昵称不可为空'
          } else {
            // 正则校验
            const reg = new RegExp(/^([\u4e00-\u9fa5A-Za-z])[\u4e00-\u9fa5A-Za-z0-9\-]{0,11}$/, 'i')
            if (reg.test(v)) {
              // 唯一校验
              const valid = await this.validNickName(v)
              if (valid) {
                this.form[field].validateStatus = status[0];
                this.form[field].help = ''
              } else {
                this.form[field].validateStatus = status[2];
                this.form[field].help = '昵称已存在'
              }
            } else {
              this.form[field].validateStatus = status[2];
              this.form[field].help = '限1-12位字符，中文或字母开头，支持中文、数字、字母、-的组合'
            }
          }
        },
        originalPassword (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '密码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        newPassword (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '密码不能为空'
          } else if (!new RegExp(this.$store.state.securityConfig.pwdReg).test(v)) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = this.$store.state.securityConfig.pwdValidMsg
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        confirmNewPassword (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '密码不能为空'
          } else if (!new RegExp(this.$store.state.securityConfig.pwdReg).test(v)) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = this.$store.state.securityConfig.pwdValidMsg
          } else if (v !== this.form.newPassword.value) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '必须与新密码一致'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        async phone (field, v, status) {
          const reg = /^1\d{10}$/;
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '手机号不能为空'
          } else if (!reg.test(v)) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '请输入正确手机号'
          } else {
            // this.form[field].help = '手机号可用'
            const isTrue = await this.validPhone(v)
            this.form[field].validateStatus = isTrue === true ? status[0] : status[2]  // true 已注册， false 未注册
            this.form[field].help = isTrue === true ? '' : '手机号暂未注册，请注册'  // true 已注册， false 未注册
          }
        },
        async newPhone (field, v, status) {
          const reg = /^1\d{10}$/;
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '手机号不能为空'
          } else if (!reg.test(v)) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '请输入正确手机号'
          } else {
            // this.form[field].help = '手机号可用'
            const isTrue = await this.validPhone(v)
            this.form[field].validateStatus =  isTrue === true ? status[2] : status[0]  // true 手机号已存在 false 手机号不存在
            this.form[field].help =  isTrue === true ? '手机号已存在，请重新输入手机号' : ''  // true 手机号已存在 false 手机号不存在
          }
        },
        async email (field, v, status) {
          const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '邮箱地址不能为空'
          } else if (!reg.test(v)) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '请输入正确的邮箱地址'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
          async newEmail (field, v, status) {
          const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '邮箱地址不能为空'
          } else if (!reg.test(v)) {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '请输入正确的邮箱地址'
          } else {
            if (!await this.validEmail(v)) {
                this.form[field].validateStatus = status[0];
                this.form[field].help = ''
            } else {
                this.form[field].validateStatus = status[2];
                this.form[field].help = '邮箱已存在'
            }
          }
        },
        // 手机验证码
        code (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '验证码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        newCode (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '验证码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        // 图片验证码
        codeImg (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '图片验证码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        //图片验证码
        vCode(field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '图片验证码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        // 邮箱验证码
        codeEmail (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '邮箱验证码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
        // 邮箱验证码
        newCodeEmail (field, v, status) {
          if (!v || v === '') {
            this.form[field].validateStatus = status[2];
            this.form[field].help = '邮箱验证码不能为空'
          } else {
            this.form[field].validateStatus = status[0];
            this.form[field].help = ''
          }
        },
    };
      // 检查有效field
      if (mapper[field]) {
        await mapper[field].call(this, field, v, status)
      }
},
    /**
     * 复写-校验表单
     * @param fields {undefined | string | Array} 校验域
     * @return {Promise<boolean>}
     */
    async validateFields (fields=undefined) {
      const { validators } = this;
      let result = true;
      if (fields) {
        // instanceof 会检视构造器，因此会存在 '' instanceof String === false 的情况
        if (typeof fields === 'string') {
          const { value } = this.form[fields];
          await validators(fields, value);
          const { validateStatus } = this.form[fields];
          if (validateStatus && validateStatus !== 'success') {
            result = false
          }
        } else if (fields instanceof Array) {
          for (let field of fields) {
            const { value } = this.form[field];
            await validators(field, value);
            const { validateStatus } = this.form[field];
            if (validateStatus && validateStatus !== 'success') {
              result = false
            }
          }
        }
      } else {
        // 循环表单key
        for (let k of Object.keys(this.form)) {
          const { value } = this.form[k];
          await validators(k, value);
          const { validateStatus } = this.form[k];
          if (validateStatus && validateStatus !== 'success') {
            result = false
          }
        }
      }

      return result
    },
    validateHandler (field, e) {
      // console.log(field,e.target.value)
      const v = e.target.value;
      this.validators(field, v)
    },
    back () {
      this.$router.go(-1)
    }
  }
}
